import { Controller } from '@hotwired/stimulus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ParallaxController extends Controller {
    static values = {
        options: { type: Object, default: {} },
    };

    static targets = ['parallaxObject'];

    scrollTrigger;

    connect() {
        this.scrollTrigger = gsap.to(this.parallaxObjectTargets, this.options);
    }

    disconnect() {
        this.scrollTrigger?.kill();
        this.scrollTrigger = null;
    }

    get options() {
        const defaultOptions = {
            yPercent: -20,
            ease: 'none',
            scrollTrigger: {
                trigger: this.element,
                start: 'top top',
                end: `+=${this.element.offsetHeight}px`,
                scrub: true,
            },
        };

        const userOptions = this.optionsValue;
        const scrollTriggerOptions = {
            ...defaultOptions.scrollTrigger,
            ...(userOptions.scrollTrigger || {}),
        };

        return {
            ...defaultOptions,
            ...userOptions,
            scrollTrigger: scrollTriggerOptions,
        };
    }
}
